import { render, staticRenderFns } from "./ViewQuote.vue?vue&type=template&id=0618081b&"
import script from "./ViewQuote.vue?vue&type=script&lang=js&"
export * from "./ViewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports